import { Paths, PathValue } from "@mctypes/global.types";
import React from "react";
import { McInputNew, McTextAreaNew } from "../../../../../../components";
import { IGKMaalingAvLufthastighetPunktavsugResultater, IGKRapport } from "@mcapps/shared/reportSchemas/gkReportSchema";
import ReportDocxImageContainer from "../../../ReportBoard/ReportDocxImageContainer";
import { Paper, Stack, Title, Box } from "@mantine/core";
const MaalingAvLufthastighetPunktavsug: React.FC<{
  onUpdateEditData: <P extends Paths<IGKRapport, 4>>(path: P, value: PathValue<IGKRapport, P>) => void;
  data: IGKMaalingAvLufthastighetPunktavsugResultater;
}> = ({ data, onUpdateEditData }) => {
  return (
    <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
      <Stack gap="xs">
        <Title order={4} fw={400}>
          Måling av lufthastighet
        </Title>
        <Stack gap={0}>
          <McInputNew
            label="Måleresultat (m/s):"
            value={data.inndata.maaleresultat}
            normalizeNumbers={true}
            type="text"
            onBlur={(e) =>
              onUpdateEditData(
                "testResultater.maalingAvLufthastighetPunktavsug.inndata.maaleresultat",
                Number(e.target.value),
              )
            }
            style={{ width: "25%" }}
          />
        </Stack>
        <Box mt="lg">
          <ReportDocxImageContainer docxImageTag="maalingAvLufthastighetPunktavsug" title="Bilde med målepunkt" />
          <div style={{ width: "50%" }}>
            <McTextAreaNew
              label="Kommentar:"
              value={data.inndata.kommentar}
              onChange={(e) =>
                onUpdateEditData("testResultater.maalingAvLufthastighetPunktavsug.inndata.kommentar", e.target.value)
              }
            />
          </div>
        </Box>
      </Stack>
    </Paper>
  );
};
export default MaalingAvLufthastighetPunktavsug;
